import React, { useMemo } from "react";
import Table from "../../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { history } from "../../_helpers";
import activeIcon from "../../assets/svg/active.svg";
import inactiveIcon from "../../assets/svg/inactive-user.svg";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";

const KioskDetails = ({ ActiveStatus }) => {
  const podKioskList = useSelector((state) => state.pod?.getPODKioskList);
  // Function to handle the selection of a Kiosk code and navigate to the Edit page
  const navigateToEditKisok = (row, fromPOD = false) => {
    const kiosksID = row?.KiosksID;

    if (!ActiveStatus) {
      showToastNotification("POD Inactivated.", "warning");
      return;
    }
    // if (!kiosksID) return; 

    if (fromPOD) {
      sessionStorage.setItem("fromPOD", "true");
    }

    history.navigate("/Admin/KioskList/Add", {
      state: { id: kiosksID, ActiveStatus: ActiveStatus },
    });
  };

  // Column configuration for the table
  const columns = useMemo(
    () => [
      {
        name: "KiosksCode",
        selector: (row) => row.KiosksCode,
        sortable: true,
        cell: (row) => (
          <div
            onClick={() => navigateToEditKisok(row, true)}
            className="Common_Link_Style"
          // Styles for clickable link
          >
            {row.KiosksCode}
          </div>
        ),
      },
      {
        name: "POD",
        selector: (row) => row.PodCode,
        sortable: true,
      },
      {
        name: "Computer",
        selector: (row) => row.ComputerName,
        sortable: true,
      },
      {
        name: "Maintenance",
        selector: (row) => row.Maintenance,
        sortable: true,
      },

      {
        name: "Status",
        selector: (row) => row.ActiveStatus, // For consistent return types
        cell: (row) => (
          <img
            src={row.ActiveStatus === 'Yes' ? activeIcon : inactiveIcon}
            alt={row.ActiveStatus === 'Yes' ? "Active" : "Inactive"}
            title={row.ActiveStatus === 'Yes' ? "Active" : "Inactive"}
            style={{ width: "24px" }} // Add some spacing between the icons
          />
        ),
        sortable: true,
        center: true,
      },
    ],
    []
  );

  // {
  //   name: "Status",
  //   selector: (row) => row.ActiveStatus, // For consistent return types
  //   cell: (row) => (
  //     <img
  //       src={row.ActiveStatus === 1 ? activeIcon : inactiveIcon}
  //       alt={row.ActiveStatus === 1 ? "Active" : "Inactive"}
  //       title={row.ActiveStatus === 1 ? "Active" : "Inactive"}
  //       style={{ width: "24px" }} // Add some spacing between the icons
  //     />
  //   ),
  //   sortable: true,
  //   center: true,
  // },
  // ],
  //   []
  // );

  return (
    <div className="card p-4 mb-3">
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <h2 className="form_title_uppercase mb-4 text-color">Kiosk Details</h2>
        <div className="d-flex flex-wrap gap-3 align-items-center"></div>
      </div>
      <Table
        //title={"POD List"}
        columns={columns}
        data={podKioskList}
      //pagination
      //onChangeRowsPerPage={handleRowPerPage}
      //onChangePage={handlePageChange}
      //totalRowCount={getPODList?.TotalRecordCount}
      //currentPage={getPODListData?.PageNo}
      //paginationPerPage={getPODListData.RowCountPerPage}
      />
    </div>
  );
}

export default React.memo(KioskDetails);
